import { useRequiredContext } from "@redotech/react-util/context";
import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { RedoTablePaddedCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { TeamContext } from "@redotech/redo-web/context/team-context";
import { Flex } from "@redotech/redo-web/flex";
import { SkeletonText } from "@redotech/redo-web/skeleton";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { memo } from "react";
import { useShipmentFlags } from "../../hooks/use-shipment-flags";
import { useSelectedRate } from "../../utils/use-group-info";
import {
  getShippingSelectionCellData,
  ShippingSelectionCell,
} from "../cells/shipping-selection-cell";

const catalogEntry = fgColumnEntries.shippingSelection;

const ShippingSelectionCellRenderer = memo(
  function ShippingSelectionCellRenderer({
    row,
  }: {
    row: FulfillmentGroupData;
  }) {
    const data = getShippingSelectionCellData(row);
    const team = useRequiredContext(TeamContext);
    const { selectedRate } = useSelectedRate([row], true);
    const flags = useShipmentFlags([row], selectedRate, team);

    if (row.ratesPendingSince) {
      return (
        <RedoTablePaddedCell>
          <SkeletonText length={32} />
        </RedoTablePaddedCell>
      );
    }

    return (
      <Flex pl="lg">
        <ShippingSelectionCell
          data={data}
          deliveryMethod={row?.deliveryMethod}
          flags={flags}
          status={row.status}
        />
      </Flex>
    );
  },
);

export const ShippingSelectionColumn: Column2<FulfillmentGroupData> = {
  key: catalogEntry.key,
  title: catalogEntry.title,
  alignment: ColumnAlignment.LEFT,
  renderNormalCell: ({ row }) => <ShippingSelectionCellRenderer row={row} />,
  onClick: (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
  },
  width: catalogEntry.defaultWidth,
  sort: catalogEntry.sortDirection,
};
